function Toggle({ isToggled, setIsToggled, localStorageKey }) {
  const handleToggle = () => {
    setIsToggled((prev) => {
      localStorage.setItem(localStorageKey, !prev);
      return !prev;
    });
  };

  const toggleStyles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '10px',
    },
    switch: {
      width: '60px',
      height: '30px',
      backgroundColor: isToggled ? '#4caf50' : '#ccc',
      borderRadius: '15px',
      position: 'relative',
      cursor: 'pointer',
      transition: 'background-color 0.3s ease',
    },
    knob: {
      width: '26px',
      height: '26px',
      backgroundColor: 'white',
      borderRadius: '50%',
      position: 'absolute',
      top: '2px',
      left: isToggled ? '32px' : '2px',
      transition: 'left 0.3s ease',
    },
    text: {
      fontSize: '16px',
    },
  };

  return (
    <div style={toggleStyles.container}>
      <div style={toggleStyles.switch} onClick={handleToggle}>
        <div style={toggleStyles.knob}></div>
      </div>
    </div>
  );
}

export default Toggle;